import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Table, Button } from 'react-bootstrap'
import * as Common from "../Common";
import { useNavigate } from 'react-router-dom';
import LoginHeader from '../Login_header';
import Menu from '../Menu';

const Master_residential_status = () => {

    const sid = sessionStorage.getItem("sessionId");
    const navigate = useNavigate();

    const [onceRun, setOnceRun] = useState(false);
    const [residentialData, setResidentialData] = useState([]);
    const [userRight, setUserRight] = useState([]);

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'MASTER_RESIDENTIAL'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                    Common.callApi(Common.apiResidentialStatus, [sid, "listResidential"], result => {
                        setResidentialData(JSON.parse(result));
                    })
                } else {
                    navigate('/'); // no query right
                }
            });
            setOnceRun(true);
        }
    }, [onceRun]);

    const exportFile = () => {
        var obj = {
            right: 'MASTER_RESIDENTIAL'
        }
        Common.callDownloadApiPost(Common.apiReport, "post", [sid, JSON.stringify(obj)]);
    }

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h2>Residential Status</h2>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {
                            userRight.query === "1" ?
                                <>&nbsp;
                                    <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={exportFile}>Export</Button>
                                </>
                                : null
                        }
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <Table responsive striped>
                            <thead>
                                <tr>
                                    <th>Serial Number</th>
                                    <th>Resident</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    residentialData.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.mrs_srno}</td>
                                            <td>{item.mrs_resident}</td>
                                            <td>{item.mrs_active == 1 ? "ACTIVE" : "INACTIVE"}</td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Container>
        </>
    )
}
export default Master_residential_status;
